import DHLPickup from "./DHL";
import FedexPickup from "./Fedex";
import TNTPickup from "./TNT";
import UPSPickup from "./UPS";
import { Redirect } from "react-router-dom";
import BringPickup from "./Bring";

function Component({ order, onChange, onPickupNotAvailable }) {
    switch (order.service.name.toUpperCase()) {
        case "DHL": {
            return (
                <DHLPickup
                    order={order}
                    onChange={onChange}
                    onPickupNotAvailable={onPickupNotAvailable}
                />
            );
        }
        case "FEDEX": {
            return (
                <FedexPickup
                    order={order}
                    onChange={onChange}
                    onPickupNotAvailable={onPickupNotAvailable}
                />
            );
        }
        case "TNT": {
            return (
                <TNTPickup
                    order={order}
                    onChange={onChange}
                    onPickupNotAvailable={onPickupNotAvailable}
                />
            );
        }
        case "UPS": {
            return (
                <UPSPickup
                    order={order}
                    onChange={onChange}
                    onPickupNotAvailable={onPickupNotAvailable}
                />
            );
        }
        case "POSTNORD": {
            return <Redirect to="/pickup/postnord" />;
        }
        case "BRING": {
            return (
                <BringPickup
                    order={order}
                    onChange={onChange}
                    onPickupNotAvailable={onPickupNotAvailable}
                />
            );
        }
        default: {
            return (
                <div>
                    <h1 className="font-medium">
                        Ring vår kundservice på 08 - 4800 12 70 eller skapa ett
                        digitalt ärende hos oss här så hjälper vi er.
                    </h1>
                </div>
            );
        }
    }
}

export default Component;
